<template>
  <ConfirmModal
    :primary-button-text="$t('estate.close-the-estate')"
    :cancel-button-text="$t('accounting.cancel')"
  >
    <template #header>
      <div class="is-flex-direction-column has-text-centered is-full-width">
        <img :src="LogInImg" alt="" />
        <p class="has-text-weight-semibold is-size-2 m-b-10">{{ $t('auth.how-to-log-in') }}</p>
        <p class="has-text-weight-normal is-size-4">{{ $t('auth.in-2-simple-steps') }}</p>
      </div>
    </template>
    <template #body>
      <div class="px-5">
        <p class="has-text-weight-semibold is-size-4">{{ $t('auth.enter-your-email') }}</p>
        <br />
        <p>{{ $t('auth.this-is-the-email-where-you') }}</p>
        <br />
        <p>{{ $t('auth.if-your-email-ends-with') }}</p>
        <br />
        <p class="has-text-weight-semibold is-size-4">{{ $t('auth.enter-your-password-step-2') }}</p>
        <br />
        <p>{{ $t('auth.your-password-must-contain') }}</p>
        <br />
        <p>{{ $t('auth.we-do-not-store') }}</p>
      </div>
    </template>
    <template #footer>
      <div class="columns is-full-width mx-4">
        <div class="column is-4 is-hidden-mobile" />
        <div class="column is-4 has-text-centered">
          <button
            class="button is-primary is-inverted is-light"
            type="button"
            @click="close"
            :data-e2e="ModalCypressAttribute.buttons.CANCEL"
          >
            <span class="has-text-weight-semibold">{{ $t('document.close') }}</span>
          </button>
        </div>
        <div class="column is-4 is-hidden-mobile" />
      </div>
    </template>
  </ConfirmModal>
</template>

<script>
import ConfirmModal from '@/modules/core/ui/components/ConfirmModal.vue';
import LogInImg from '@/assets/illustrations/log-in.svg';
import { ModalCypressAttribute } from '@/modules/core/app/constants/ModalCypressAttribute';
import { ModalMixin } from '@/modules/core/ui/mixins/ModalMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'HelpMeLogInModal',
  mixins: [ModalMixin],
  components: { ConfirmModal },
  static: {
    ModalCypressAttribute
  },
  local() {
    return {
      LogInImg
    };
  }
};
</script>
<style scoped>
.modal.is-active footer {
  justify-content: center !important;
}
</style>
